import * as React from "react";
const SvgShoppingCart = (props) => /* @__PURE__ */ React.createElement("svg", { id: "svg2001", xmlSpace: "preserve", viewBox: "0 0 682.66669 682.66669", xmlns: "http://www.w3.org/2000/svg", xmlnsSvg: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("defs", { id: "defs2005" }, /* @__PURE__ */ React.createElement("clipPath", { clipPathUnits: "userSpaceOnUse", id: "clipPath2015" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,512 H 512 V 0 H 0 Z", id: "path2013" }))), /* @__PURE__ */ React.createElement("g", { id: "g2007", transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)" }, /* @__PURE__ */ React.createElement("g", { id: "g2009" }, /* @__PURE__ */ React.createElement("g", { id: "g2011", clipPath: "url(#clipPath2015)" }, /* @__PURE__ */ React.createElement("g", { id: "g2017", transform: "translate(106,406)" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,0 H 391 L 331,-210 H 60", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 30,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path2019" })), /* @__PURE__ */ React.createElement("g", { id: "g2021", transform: "translate(256,76)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 c 0,-16.568 -13.432,-30 -30,-30 -16.568,0 -30,13.432 -30,30 0,16.568 13.432,30 30,30 C -13.432,30 0,16.568 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 30,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path2023" })), /* @__PURE__ */ React.createElement("g", { id: "g2025", transform: "translate(407,76)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 c 0,-16.568 -13.432,-30 -30,-30 -16.568,0 -30,13.432 -30,30 0,16.568 13.432,30 30,30 C -13.432,30 0,16.568 0,0 Z", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 30,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path2027" })), /* @__PURE__ */ React.createElement("g", { id: "g2029", transform: "translate(437,136)" }, /* @__PURE__ */ React.createElement("path", { d: "m 0,0 h -252.459 c -22.301,0 -36.806,23.469 -26.833,43.417 L -271,60", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 30,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path2031" })), /* @__PURE__ */ React.createElement("g", { id: "g2033", transform: "translate(15,466)" }, /* @__PURE__ */ React.createElement("path", { d: "M 0,0 H 73.861 C 99.402,-89.409 151,-270 151,-270", style: {
  fill: "none",
  stroke: "#26948f",
  strokeWidth: 30,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, id: "path2035" }))))));
export default SvgShoppingCart;
